module.exports = __webpack_public_path__ + "media/icon_click.8a422ef4.ogg";